const numberDecimals = REALPRESS_GLOBAL_OBJECT.number_decimals || 2;
const currencySymbol = REALPRESS_GLOBAL_OBJECT.currency_symbol || '';
const thousandsSeparator = REALPRESS_GLOBAL_OBJECT.thousands_separator || '';
const currencyPosition = REALPRESS_GLOBAL_OBJECT.currency_position || 'left';
const realpressPriceHelper = ( price ) => {
	price = ( price / 1 ).toFixed( numberDecimals );
	price = price.toString().replace( /\B(?=(\d{3})+(?!\d))/g, thousandsSeparator );
	switch ( currencyPosition ) {
	case 'left':
		price = currencySymbol + price;
		break;
	case 'right':
		price = price + currencySymbol;
		break;
	case 'left_space':
		price = currencySymbol + ' ' + price;
		break;
	case 'right_space':
		price = price + ' ' + currencySymbol;
		break;
	default:
		break;
	}

	return price;
};

export { realpressPriceHelper };
